// extracted by mini-css-extract-plugin
export default {"container":"DropdownView_container__jZLtv","trigger":"DropdownView_trigger__ESWmY","spin":"DropdownView_spin__9FceU"};